var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-rating"},[_vm._l((Number(_vm.scale)),function(n){return _c('i',{key:n,class:[
      'c-icon',
      _vm.icons[_vm.variation] ? _vm.icons[_vm.variation]['empty'] : _vm.icons['star']['empty'] ]})}),_c('div',{staticClass:"icons-filled",style:({
      width: _vm.ratingWidth + '%',
    })},_vm._l((Number(_vm.scale)),function(n){return _c('i',{key:n,class:[
        'c-icon',
        _vm.icons[_vm.variation]
          ? _vm.icons[_vm.variation]['filled']
          : _vm.icons['star']['filled'] ]})}),0)],2)}
var staticRenderFns = []

export { render, staticRenderFns }